import { initVariantPanelToggle } from "common/variantPanels";

initVariantPanelToggle("data-product-ingredients", "data-variant-ingredients-panel");
